import { BaseRowNumberModel } from '../domain-models/base-row-number-model';
import { ItemViewModel } from './item-view-model';
import { NumericPropertyViewModel } from './base-type/numeric-property-view-model';
import { IdentityInterface } from '@nts/std/interfaces';


export abstract class BaseRowNumberItemViewModel<
    TModel extends BaseRowNumberModel<TIdentity>,
    TIdentity extends IdentityInterface
> extends ItemViewModel<TModel, TIdentity> {
    private _rowNumber: NumericPropertyViewModel<number>;

    public get rowNumber(): NumericPropertyViewModel<number> {
        return this.getNumericPropertyViewModel<number>({
            action: (value) => this._rowNumber = value,
            value: this._rowNumber,
            propertyName: 'rowNumber'
        });
    }
}
